/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Account API
 * This API is for managing Accounts, Organizations and Workspaces.
 * OpenAPI spec version: 1.1.9
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountsControllerCreate201,
  AccountsControllerCreate400,
  AccountsControllerDelete404,
  AccountsControllerGet200,
  AccountsControllerGet404,
  AccountsControllerGetAll200,
  AccountsControllerGetAllParams,
  AccountsControllerUpdate200,
  AccountsControllerUpdate400,
  AccountsControllerUpdate404,
  CreateAccountDto,
  UpdateAccountDto
} from '../../schemas';

import { customFetch } from '../../../../../clients/customInstance';
import type { ErrorType } from '../../../../../clients/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type accountsControllerHealthResponse200 = {
  data: void
  status: 200
}

export type accountsControllerHealthResponseSuccess = (accountsControllerHealthResponse200) & {
  headers: Headers;
};
;

export type accountsControllerHealthResponse = (accountsControllerHealthResponseSuccess)

export const getAccountsControllerHealthUrl = () => {


  

  return `/accounts/health`
}

export const accountsControllerHealth = async ( options?: RequestInit): Promise<accountsControllerHealthResponse> => {
  
  return customFetch<accountsControllerHealthResponse>(getAccountsControllerHealthUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getAccountsControllerHealthQueryKey = () => {
    return [
    `/accounts/health`
    ] as const;
    }

    
export const getAccountsControllerHealthQueryOptions = <TData = Awaited<ReturnType<typeof accountsControllerHealth>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountsControllerHealthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountsControllerHealth>>> = ({ signal }) => accountsControllerHealth({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountsControllerHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountsControllerHealthQueryResult = NonNullable<Awaited<ReturnType<typeof accountsControllerHealth>>>
export type AccountsControllerHealthQueryError = ErrorType<unknown>


export function useAccountsControllerHealth<TData = Awaited<ReturnType<typeof accountsControllerHealth>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountsControllerHealth>>,
          TError,
          Awaited<ReturnType<typeof accountsControllerHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountsControllerHealth<TData = Awaited<ReturnType<typeof accountsControllerHealth>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountsControllerHealth>>,
          TError,
          Awaited<ReturnType<typeof accountsControllerHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountsControllerHealth<TData = Awaited<ReturnType<typeof accountsControllerHealth>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountsControllerHealth<TData = Awaited<ReturnType<typeof accountsControllerHealth>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountsControllerHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Get all accounts paginated
 * @summary Get all accounts
 */
export type accountsControllerGetAllResponse200 = {
  data: AccountsControllerGetAll200
  status: 200
}

export type accountsControllerGetAllResponseSuccess = (accountsControllerGetAllResponse200) & {
  headers: Headers;
};
;

export type accountsControllerGetAllResponse = (accountsControllerGetAllResponseSuccess)

export const getAccountsControllerGetAllUrl = (params?: AccountsControllerGetAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/accounts?${stringifiedParams}` : `/accounts`
}

export const accountsControllerGetAll = async (params?: AccountsControllerGetAllParams, options?: RequestInit): Promise<accountsControllerGetAllResponse> => {
  
  return customFetch<accountsControllerGetAllResponse>(getAccountsControllerGetAllUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getAccountsControllerGetAllQueryKey = (params?: AccountsControllerGetAllParams,) => {
    return [
    `/accounts`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getAccountsControllerGetAllQueryOptions = <TData = Awaited<ReturnType<typeof accountsControllerGetAll>>, TError = ErrorType<unknown>>(params?: AccountsControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGetAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountsControllerGetAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountsControllerGetAll>>> = ({ signal }) => accountsControllerGetAll(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGetAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountsControllerGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof accountsControllerGetAll>>>
export type AccountsControllerGetAllQueryError = ErrorType<unknown>


export function useAccountsControllerGetAll<TData = Awaited<ReturnType<typeof accountsControllerGetAll>>, TError = ErrorType<unknown>>(
 params: undefined |  AccountsControllerGetAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGetAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountsControllerGetAll>>,
          TError,
          Awaited<ReturnType<typeof accountsControllerGetAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountsControllerGetAll<TData = Awaited<ReturnType<typeof accountsControllerGetAll>>, TError = ErrorType<unknown>>(
 params?: AccountsControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGetAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountsControllerGetAll>>,
          TError,
          Awaited<ReturnType<typeof accountsControllerGetAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountsControllerGetAll<TData = Awaited<ReturnType<typeof accountsControllerGetAll>>, TError = ErrorType<unknown>>(
 params?: AccountsControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGetAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all accounts
 */

export function useAccountsControllerGetAll<TData = Awaited<ReturnType<typeof accountsControllerGetAll>>, TError = ErrorType<unknown>>(
 params?: AccountsControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGetAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountsControllerGetAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Create a new account with the provided data
 * @summary Create a new account
 */
export type accountsControllerCreateResponse201 = {
  data: AccountsControllerCreate201
  status: 201
}

export type accountsControllerCreateResponse400 = {
  data: AccountsControllerCreate400
  status: 400
}

export type accountsControllerCreateResponseSuccess = (accountsControllerCreateResponse201) & {
  headers: Headers;
};
export type accountsControllerCreateResponseError = (accountsControllerCreateResponse400) & {
  headers: Headers;
};

export type accountsControllerCreateResponse = (accountsControllerCreateResponseSuccess | accountsControllerCreateResponseError)

export const getAccountsControllerCreateUrl = () => {


  

  return `/accounts`
}

export const accountsControllerCreate = async (createAccountDto: CreateAccountDto, options?: RequestInit): Promise<accountsControllerCreateResponse> => {
  
  return customFetch<accountsControllerCreateResponse>(getAccountsControllerCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAccountDto,)
  }
);}
  



export const getAccountsControllerCreateMutationOptions = <TError = ErrorType<AccountsControllerCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountsControllerCreate>>, TError,{data: CreateAccountDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof accountsControllerCreate>>, TError,{data: CreateAccountDto}, TContext> => {

const mutationKey = ['accountsControllerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountsControllerCreate>>, {data: CreateAccountDto}> = (props) => {
          const {data} = props ?? {};

          return  accountsControllerCreate(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AccountsControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof accountsControllerCreate>>>
    export type AccountsControllerCreateMutationBody = CreateAccountDto
    export type AccountsControllerCreateMutationError = ErrorType<AccountsControllerCreate400>

    /**
 * @summary Create a new account
 */
export const useAccountsControllerCreate = <TError = ErrorType<AccountsControllerCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountsControllerCreate>>, TError,{data: CreateAccountDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountsControllerCreate>>,
        TError,
        {data: CreateAccountDto},
        TContext
      > => {
      return useMutation(getAccountsControllerCreateMutationOptions(options), queryClient);
    }
    /**
 * Get an account by id
 * @summary Get an account by id
 */
export type accountsControllerGetResponse200 = {
  data: AccountsControllerGet200
  status: 200
}

export type accountsControllerGetResponse404 = {
  data: AccountsControllerGet404
  status: 404
}

export type accountsControllerGetResponseSuccess = (accountsControllerGetResponse200) & {
  headers: Headers;
};
export type accountsControllerGetResponseError = (accountsControllerGetResponse404) & {
  headers: Headers;
};

export type accountsControllerGetResponse = (accountsControllerGetResponseSuccess | accountsControllerGetResponseError)

export const getAccountsControllerGetUrl = (accountId: string,) => {


  

  return `/accounts/${accountId}`
}

export const accountsControllerGet = async (accountId: string, options?: RequestInit): Promise<accountsControllerGetResponse> => {
  
  return customFetch<accountsControllerGetResponse>(getAccountsControllerGetUrl(accountId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getAccountsControllerGetQueryKey = (accountId: string,) => {
    return [
    `/accounts/${accountId}`
    ] as const;
    }

    
export const getAccountsControllerGetQueryOptions = <TData = Awaited<ReturnType<typeof accountsControllerGet>>, TError = ErrorType<AccountsControllerGet404>>(accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountsControllerGetQueryKey(accountId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountsControllerGet>>> = ({ signal }) => accountsControllerGet(accountId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountsControllerGetQueryResult = NonNullable<Awaited<ReturnType<typeof accountsControllerGet>>>
export type AccountsControllerGetQueryError = ErrorType<AccountsControllerGet404>


export function useAccountsControllerGet<TData = Awaited<ReturnType<typeof accountsControllerGet>>, TError = ErrorType<AccountsControllerGet404>>(
 accountId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof accountsControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountsControllerGet<TData = Awaited<ReturnType<typeof accountsControllerGet>>, TError = ErrorType<AccountsControllerGet404>>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof accountsControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountsControllerGet<TData = Awaited<ReturnType<typeof accountsControllerGet>>, TError = ErrorType<AccountsControllerGet404>>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an account by id
 */

export function useAccountsControllerGet<TData = Awaited<ReturnType<typeof accountsControllerGet>>, TError = ErrorType<AccountsControllerGet404>>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountsControllerGetQueryOptions(accountId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Update an existing account with the provided data
 * @summary Update an account
 */
export type accountsControllerUpdateResponse200 = {
  data: AccountsControllerUpdate200
  status: 200
}

export type accountsControllerUpdateResponse400 = {
  data: AccountsControllerUpdate400
  status: 400
}

export type accountsControllerUpdateResponse404 = {
  data: AccountsControllerUpdate404
  status: 404
}

export type accountsControllerUpdateResponseSuccess = (accountsControllerUpdateResponse200) & {
  headers: Headers;
};
export type accountsControllerUpdateResponseError = (accountsControllerUpdateResponse400 | accountsControllerUpdateResponse404) & {
  headers: Headers;
};

export type accountsControllerUpdateResponse = (accountsControllerUpdateResponseSuccess | accountsControllerUpdateResponseError)

export const getAccountsControllerUpdateUrl = (accountId: string,) => {


  

  return `/accounts/${accountId}`
}

export const accountsControllerUpdate = async (accountId: string,
    updateAccountDto: UpdateAccountDto, options?: RequestInit): Promise<accountsControllerUpdateResponse> => {
  
  return customFetch<accountsControllerUpdateResponse>(getAccountsControllerUpdateUrl(accountId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAccountDto,)
  }
);}
  



export const getAccountsControllerUpdateMutationOptions = <TError = ErrorType<AccountsControllerUpdate400 | AccountsControllerUpdate404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountsControllerUpdate>>, TError,{accountId: string;data: UpdateAccountDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof accountsControllerUpdate>>, TError,{accountId: string;data: UpdateAccountDto}, TContext> => {

const mutationKey = ['accountsControllerUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountsControllerUpdate>>, {accountId: string;data: UpdateAccountDto}> = (props) => {
          const {accountId,data} = props ?? {};

          return  accountsControllerUpdate(accountId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AccountsControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof accountsControllerUpdate>>>
    export type AccountsControllerUpdateMutationBody = UpdateAccountDto
    export type AccountsControllerUpdateMutationError = ErrorType<AccountsControllerUpdate400 | AccountsControllerUpdate404>

    /**
 * @summary Update an account
 */
export const useAccountsControllerUpdate = <TError = ErrorType<AccountsControllerUpdate400 | AccountsControllerUpdate404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountsControllerUpdate>>, TError,{accountId: string;data: UpdateAccountDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountsControllerUpdate>>,
        TError,
        {accountId: string;data: UpdateAccountDto},
        TContext
      > => {
      return useMutation(getAccountsControllerUpdateMutationOptions(options), queryClient);
    }
    /**
 * Soft delete an account by id
 * @summary Delete an account
 */
export type accountsControllerDeleteResponse204 = {
  data: void
  status: 204
}

export type accountsControllerDeleteResponse404 = {
  data: AccountsControllerDelete404
  status: 404
}

export type accountsControllerDeleteResponseSuccess = (accountsControllerDeleteResponse204) & {
  headers: Headers;
};
export type accountsControllerDeleteResponseError = (accountsControllerDeleteResponse404) & {
  headers: Headers;
};

export type accountsControllerDeleteResponse = (accountsControllerDeleteResponseSuccess | accountsControllerDeleteResponseError)

export const getAccountsControllerDeleteUrl = (accountId: string,) => {


  

  return `/accounts/${accountId}`
}

export const accountsControllerDelete = async (accountId: string, options?: RequestInit): Promise<accountsControllerDeleteResponse> => {
  
  return customFetch<accountsControllerDeleteResponse>(getAccountsControllerDeleteUrl(accountId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getAccountsControllerDeleteMutationOptions = <TError = ErrorType<AccountsControllerDelete404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountsControllerDelete>>, TError,{accountId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof accountsControllerDelete>>, TError,{accountId: string}, TContext> => {

const mutationKey = ['accountsControllerDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountsControllerDelete>>, {accountId: string}> = (props) => {
          const {accountId} = props ?? {};

          return  accountsControllerDelete(accountId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AccountsControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof accountsControllerDelete>>>
    
    export type AccountsControllerDeleteMutationError = ErrorType<AccountsControllerDelete404>

    /**
 * @summary Delete an account
 */
export const useAccountsControllerDelete = <TError = ErrorType<AccountsControllerDelete404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountsControllerDelete>>, TError,{accountId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountsControllerDelete>>,
        TError,
        {accountId: string},
        TContext
      > => {
      return useMutation(getAccountsControllerDeleteMutationOptions(options), queryClient);
    }
    export type accountsControllerHardDeleteResponse204 = {
  data: void
  status: 204
}

export type accountsControllerHardDeleteResponseSuccess = (accountsControllerHardDeleteResponse204) & {
  headers: Headers;
};
;

export type accountsControllerHardDeleteResponse = (accountsControllerHardDeleteResponseSuccess)

export const getAccountsControllerHardDeleteUrl = (accountId: string,) => {


  

  return `/accounts/${accountId}/hard`
}

export const accountsControllerHardDelete = async (accountId: string, options?: RequestInit): Promise<accountsControllerHardDeleteResponse> => {
  
  return customFetch<accountsControllerHardDeleteResponse>(getAccountsControllerHardDeleteUrl(accountId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getAccountsControllerHardDeleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountsControllerHardDelete>>, TError,{accountId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof accountsControllerHardDelete>>, TError,{accountId: string}, TContext> => {

const mutationKey = ['accountsControllerHardDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountsControllerHardDelete>>, {accountId: string}> = (props) => {
          const {accountId} = props ?? {};

          return  accountsControllerHardDelete(accountId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AccountsControllerHardDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof accountsControllerHardDelete>>>
    
    export type AccountsControllerHardDeleteMutationError = ErrorType<unknown>

    export const useAccountsControllerHardDelete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountsControllerHardDelete>>, TError,{accountId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountsControllerHardDelete>>,
        TError,
        {accountId: string},
        TContext
      > => {
      return useMutation(getAccountsControllerHardDeleteMutationOptions(options), queryClient);
    }
    